const getters = {
    elearn: (state) => state.elearn,
    loading: state => state.loading,
    
};

export default getters;